import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { BreakpointService } from '@spartacus/storefront';
import { Store } from '@ngrx/store';
import { ModalRef, ModalService } from '@app/custom/features/modal';
import { RrsFacetListComponent } from '@app/custom/features/rrs-product-listing/components/rrs-facets/rrs-facet-list/rrs-facet-list.component';

@Component({
  selector: 'rrs-facet-list-button',
  templateUrl: './rrs-facet-list-button.component.html',
  styleUrls: ['./rrs-facet-list-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RrsFacetListButtonComponent {
  @ViewChild('trigger') trigger!: ElementRef<HTMLElement>;

  modalRef!: ModalRef;
  constructor(
    protected store: Store,
    protected breakpointService: BreakpointService,
    protected modalService: ModalService
  ) {}

  launch(): void {
    this.modalRef = this.modalService.open(RrsFacetListComponent, {
      windowClass: 'filter-dialog',
    });
    this.modalRef.componentInstance.isInDialog = true;
  }
}
